import React from 'react';
import { useXFlowApp, XFlowAppExtensionModule } from '@antv/xflow-core';
import { ContextMenuConfig } from './config';
import { createModule } from './module';
import { ContextMenuRender } from './components';
export const CONFIG_TYPE = 'CanvasContextMenu';
export const CanvasContextMenu = props => {
    const xflow = useXFlowApp();
    const canRender = !!xflow;
    /** 获取ContextMenu的配置 */
    const contextMenuConfig = React.useMemo(() => (props.config ? props.config : new ContextMenuConfig()), [props.config]);
    return (React.createElement(XFlowAppExtensionModule, { createModule: createModule, config: contextMenuConfig }, canRender && React.createElement(ContextMenuRender, { config: contextMenuConfig })));
};
export const createCtxMenuConfig = (addOptions) => (props) => {
    /** bridge config and props */
    const proxy = React.useMemo(() => ({ getValue: () => ({}) }), []);
    proxy.getValue = () => props;
    const toolbarConfig = React.useMemo(() => {
        const config = new ContextMenuConfig();
        addOptions(config, proxy);
        return config;
    }, [proxy]);
    return toolbarConfig;
};
//# sourceMappingURL=index.js.map